import { render, staticRenderFns } from "./ComboboxEixoGrupo.vue?vue&type=template&id=1587834f"
import script from "./ComboboxEixoGrupo.vue?vue&type=script&lang=js"
export * from "./ComboboxEixoGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports